export default __webpack_public_path__ + "static/media/agency5.e0824fa8.png";